<template>
  <v-card flat>

    <v-progress-linear v-if="utility.dataLoading" color="blue" value="50" indeterminate></v-progress-linear>
    <v-form v-model="regReportFormValid">
      <v-toolbar dark color="primary">
        <v-toolbar-title>Редактировать отчет "{{ regReport.testId }}"</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon v-on:click="$emit('close-dlg')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-flex align-center justify-space-between>
        <v-container fluid>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field prepend-icon="vpn_key" name="reg_report_test" class="notranslate"
                            label="Код теста (6 последних букв/цифр)"
                            v-model="regReport.testId"
                            mask="NNNNNN"
                            :rules="[rules.required]"
                            type="text"
                            required></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="false">
              <v-text-field prepend-icon="lock_open" name="reg_report_id" class="notranslate"
                            label="Id отчета (необязательно)" v-model="regReport.reportId"
                            type="text"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field prepend-icon="title" name="reg_report_title" class="notranslate"
                            label="Заголовок" v-model="regReport.title"
                            type="text"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field prepend-icon="dashboard" name="reg_report_template" class="notranslate"
                            label="Шаблон" v-model="regReport.template"
                            :rules="[rules.required]"
                            type="text"
                            required></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-card-title>Данные отчета</v-card-title>
              <v-textarea v-if="false" prepend-icon="archive" name="reg_report_data" class="notranslate"
                          label="Данные отчета" v-model="regReport.data"
                          :rules="[rules.isValidJson]"
                          type="text"
              ></v-textarea>

              <v-data-table class="py-3"

                            caption="Данные отчета"
                            :expand="expand"
                            :headers="headers"
                            :items="regReport.results"
                            item-key="Gene-refGene"
                            :loading="utility.dataLoading"
                            :rows-per-page-items='[ 10, 25, 50, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'
                            pagination.sync="{rowsPerPage:10}"
              >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template v-slot:items="props">
                  <tr class="first-row" @click="props.expanded = !props.expanded">
                    <td class="chk">
                      <v-checkbox v-model="props.item['show']"></v-checkbox>
                    </td>

                    <td class="">{{ props.item['Gene-refGene'] }}</td>
                    <td class="">{{ props.item['ACMG_classification'] }}</td>
                    <td class="">{{ props.item['Probability_Path'] }}</td>
                    <td class="varsome"><a :href="props.item['Varsome_link']"
                                           target="_blank">{{ props.item['Varsome_link_N'] }}</a></td>

                    <td class="chr-plus" :title="props.item['chrPlus']">{{ props.item['chrPlus'] }}</td>

                    <td class="ct">{{ props.item['Func-refGene'] }}</td>
                    <td class="ct">{{ props.item['ExonicFunc-refGene'] }}</td>
                    <td class="ct">{{ props.item['gnomAD_exome_ALL'] }}</td>
                    <td class="ct">{{ props.item['gnomAD_genome_ALL'] }}</td>
                    <td class="ct">{{ props.item['ZD8MG017_N'] }}</td>

                    <td class="aachange" :title="props.item['AAChange-refGene']">{{
                        props.item['AAChange-refGene']
                      }}
                    </td>
                  </tr>
                  <tr class="second-row" v-if="props.item['Disease_description-refGene']"
                      @click="props.expanded = !props.expanded">
                    <td colspan="12">
                      <b>Disease description:</b>
                      <div v-html="props.item['Disease_description-refGene']"></div>
                    </td>
                  </tr>

                </template>
                <template v-slot:expand="props">
                  <v-card flat>
                    <v-card-text style="background: #f9f9f9">
                      <div class="common-block" v-if="props.item['Function_description-refGene']"><b>Function
                        description:</b><br>
                        <div v-html="props.item['Function_description-refGene']"></div>
                      </div>

                      <div class="common-block" v-if="props.item['CLNDISDB']"><b>CLNDISDB:</b><br>
                        <div v-html="props.item['CLNDISDB']"></div>
                      </div>

                      <table class="v-datatable v-table theme--light">
                        <thead>
                        <tr>
                          <th>avsnp150</th>

                          <th>CLNALLELEID</th>
                          <th>CLNDN</th>
                          <th>CLNDISDB</th>
                          <th>CLNREVSTAT</th>
                          <th>CLNSIG</th>
                          <th>SIFT converted rankscore</th>
                          <th>SIFT pred</th>
                          <th>Polyphen2 HDIV score</th>
                          <th>Polyphen2 HDIV pred</th>

                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td class="ctd">{{ props.item['avsnp150'] }}</td>

                          <td class="ctd">{{ props.item['CLNALLELEID'] }}</td>
                          <td class="ctd">{{ props.item['CLNDN'] }}</td>
                          <td class="ctd" style="max-width: 450px" v-html="props.item['CLNDISDB']"></td>
                          <td class="ctd">{{ props.item['CLNREVSTAT'] }}</td>
                          <td class="ctd">{{ props.item['CLNSIG'] }}</td>
                          <td class="ctd">{{ props.item['SIFT_converted_rankscore'] }}</td>

                          <td class="ctd">{{ props.item['SIFT_pred'] }}</td>
                          <td class="ctd">{{ props.item['Polyphen2_HDIV_score'] }}</td>
                          <td class="ctd">{{ props.item['Polyphen2_HDIV_pred'] }}</td>

                        </tr>
                        </tbody>
                      </table>

                      <table class="v-datatable v-table theme--light">
                        <thead>
                        <tr>
                          <th>REVEL</th>
                          <th>REVEL rankscore</th>
                          <th>InterVar automated</th>
                          <th>FORMAT</th>

                          <th>PrimateAI pred</th>
                          <th>PrimateAI rankscore</th>

                          <th>ClinPred pred</th>
                          <th>ClinPred rankscore</th>

                          <th>CADD raw</th>
                          <th>Interpro domain</th>

                          <th>dbscSNV ADA SCORE</th>
                          <th>dbscSNV RF SCORE</th>


                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <td class="ctd">{{ props.item['REVEL'] }}</td>
                          <td class="ctd">{{ props.item['REVEL_rankscore'] }}</td>
                          <td class="ctd">{{ props.item['InterVar_automated'] }}</td>
                          <td class="ctd">{{ props.item['FORMAT'] }}</td>

                          <td class="ctd">{{ props.item['PrimateAI_pred'] }}</td>
                          <td class="ctd">{{ props.item['PrimateAI_rankscore'] }}</td>

                          <td class="ctd">{{ props.item['ClinPred_pred'] }}</td>
                          <td class="ctd">{{ props.item['ClinPred_rankscore'] }}</td>

                          <td class="ctd">{{ props.item['CADD_raw'] }}</td>
                          <td class="ctd">{{ props.item['Interpro_domain'] }}</td>

                          <td class="ctd">{{ props.item['dbscSNV_ADA_SCORE'] }}</td>
                          <td class="ctd">{{ props.item['dbscSNV_RF_SCORE'] }}</td>


                        </tr>
                        </tbody>
                      </table>

                      <div>
                        PVS/PS/PM/PP/BS/BP/BA<br>
                        {{ props.item['PVS1_contrib'] }}
                        / {{ props.item['PS1_contrib'] }}-{{
                          props.item['PS2_contrib_merged']
                        }}-{{ props.item['PS3_contrib'] }}-{{ props.item['PS4_contrib'] }}
                        / {{ props.item['PM1_contrib'] }}-{{ props.item['PM2_contrib'] }}-{{
                          props.item['PM4_contrib']
                        }}-{{ props.item['PM5_contrib'] }}
                        / {{ props.item['PP2_contrib'] }}-{{ props.item['PP3_contrib'] }}-{{
                          props.item['PP5_contrib']
                        }}
                        / {{ props.item['BS1_contrib'] }}-{{ props.item['BS2_contrib'] }}-{{
                          props.item['BS3_contrib']
                        }}
                        / {{ props.item['BP1_contrib'] }}-{{ props.item['BP3_contrib'] }}-{{
                          props.item['BP4_contrib']
                        }}-{{ props.item['BP6_contrib'] }}-{{ props.item['BP7_contrib'] }}
                        / {{ props.item['BA_1_contrib\n'] }}

                      </div>

                      <div class="pb-block">
                        <div class="pb-it">
                          <div class="pb-h">PVS</div>
                          <div class="pb-el-list">
                            <div class="pb-el">
                              <div>1</div>
                              <div>{{ props.item['PVS1_contrib'] }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="pb-it">
                          <div class="pb-h">PS</div>
                          <div class="pb-el-list">
                            <div class="pb-el">
                              <div>1</div>
                              <div>{{ props.item['PS1_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>2</div>
                              <div>{{ props.item['PS2_contrib_merged'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>3</div>
                              <div>{{ props.item['PS3_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>4</div>
                              <div>{{ props.item['PS4_contrib'] }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="pb-it">
                          <div class="pb-h">PM</div>
                          <div class="pb-el-list">
                            <div class="pb-el">
                              <div>1</div>
                              <div>{{ props.item['PM1_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>2</div>
                              <div>{{ props.item['PM2_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>4</div>
                              <div>{{ props.item['PM4_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>5</div>
                              <div>{{ props.item['PM5_contrib'] }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="pb-it">
                          <div class="pb-h">PP</div>
                          <div class="pb-el-list">
                            <div class="pb-el">
                              <div>2</div>
                              <div>{{ props.item['PP2_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>3</div>
                              <div>{{ props.item['PP3_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>5</div>
                              <div>{{ props.item['PP5_contrib'] }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="pb-it">
                          <div class="pb-h">BS</div>
                          <div class="pb-el-list">
                            <div class="pb-el">
                              <div>1</div>
                              <div>{{ props.item['BS1_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>2</div>
                              <div>{{ props.item['BS2_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>3</div>
                              <div>{{ props.item['BS3_contrib'] }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="pb-it">
                          <div class="pb-h">BP</div>
                          <div class="pb-el-list">
                            <div class="pb-el">
                              <div>1</div>
                              <div>{{ props.item['BP1_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>3</div>
                              <div>{{ props.item['BP3_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>4</div>
                              <div>{{ props.item['BP4_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>6</div>
                              <div>{{ props.item['BP6_contrib'] }}</div>
                            </div>
                            <div class="pb-el">
                              <div>7</div>
                              <div>{{ props.item['BP7_contrib'] }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="pb-it">
                          <div class="pb-h">BA</div>
                          <div class="pb-el-list">
                            <div class="pb-el">
                              <div>1</div>
                              <div>{{ props.item['BA_1_contrib\n'] }}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </v-card-text>
                  </v-card>
                </template>

                <template v-slot:no-results>
                  <v-alert :value="true" color="error" icon="warning" class="notranslate">
                    Ничего не найдено.
                  </v-alert>
                </template>
              </v-data-table>

            </v-flex>
            <v-flex xs12>
              <v-switch prepend-icon="done" class="notranslate"
                        :label="`Отчет ${regReport.isReady? '':'не '} готов`"
                        v-model="regReport.isReady"
              ></v-switch>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-btn block large color="primary" v-if="reportId"
                     :disabled="!regReportFormValid"
                     @click="updateReport">Сохранить
              </v-btn>
            </v-flex>
            <v-flex v-if="inModal" xs12 offset-sm1 sm5 md5>
              <v-btn large block
                     v-on:click="$emit('close-dlg')">Закрыть
              </v-btn>
            </v-flex>

          </v-layout>
        </v-container>

      </v-flex>
    </v-form>
  </v-card>
</template>

<script>

function rebuildLinks(item) {
  item = item.replace(/PubMed:(\d+)/g, ' <a href="https://pubmed.ncbi.nlm.nih.gov/$1/" target="_blank">PubMed:$1</a> ')
  item = item.replace(/MedGen:([A-Z0-9]+)/g, ' <a href="https://www.ncbi.nlm.nih.gov/medgen/$1/" target="_blank">MedGen:$1</a> ')
  item = item.replace(/Human_Phenotype_Ontology:HP:(\d+)/g, '<a href="https://hpo.jax.org/app/browse/term/HP:$1" target="_blank">HPO:$1</a>')
  item = item.replace(/MONDO:MONDO:(\d+)/g, '<a href="https://monarchinitiative.org/disease/MONDO:$1" target="_blank">MONDO:$1</a>')
  return item
}

function cleanup(item) {
  item = item.trim()
  return item === '.' ? '' : item
}

export default {
  name: "RegReport",
  props: ['reportId', 'inModal'],

  data: () => ({
    expand: false,

    regReportFormValid: false,
    regReportFormIsDirty: false,
    regReport: {
      testId: "",
      reportId: "",
      title: "",
      data: "",
      results: [],
      dataFile: "",
      isReady: false,
      template: "generic"
    },
    utility: {
      dataLoading: false,
      completed: false
    },
    rules: {
      required: value => !!value || 'Required.',
      isValidJson: value => {
        if (!value) return false;
        try {
          if (JSON.parse(value)) return false;
        } catch {
          return 'Not valid JSON.';
        }
        return 'Not valid JSON.';
      },
      counter: value => value.length <= 20 || 'Max 20 characters'
    }
  }),
  methods: {
    restart: function () {
      this.regReport = {
        testId: "",
        reportId: "",
        title: "",
        data: "",
        results: [],
        dataFile: "",
        isReady: false,
        template: "generic"
      }
      this.utility.completed = false
    },
    registerReport: function () {
      var this_ = this;

      var output = {}
      Object.assign(output, this.regReport)
      if (output.data) output.data = JSON.parse(this.regReport.data)
      if (!output.reportId) output.reportId = output.testId + (Math.floor(+new Date() / 1000))

      this.$store.dispatch('regReport', output).then(function (response) {
        this_.response = response
        if (this_.response.status === 200) this_.utility.completed = true
        else this_.$store.dispatch('processError', this_.response)
      })
    },
    updateReport: function () {
      var this_ = this;

      var output = {}
      Object.assign(output, this.regReport)
      if (output.data) output.data = JSON.parse(this.regReport.data)
      if (!output.reportId) output.reportId = output.testId + (Math.floor(+new Date() / 1000))

      this.$store.dispatch('adminReportSet', output).then(function (response) {
        this_.response = response

        if (this_.response.status === 200) {
          if (this_.inModal) {
            this_.$emit('close-dlg')
            this_.$emit('reload-list')
          } else this_.utility.completed = true
        }

        this_.$store.dispatch('processError', this_.response)
      })
    },
    loadReport: function () {
      var this_ = this;
      this_.utility.completed = false
      this_.utility.dataLoading = true
      this.$store.dispatch('adminReportGet', {reportId: this.reportId}).then(function (response) {
        this_.response = response
        this_.$store.dispatch('processError', this_.response)
        if (this_.response.status === 200) {
          this_.regReport = this_.response.data.report
          this_.regReport.results = JSON.parse(this_.response.data.report.data).results
          this_.regReport.results.forEach((item) => {
            item['show'] = item['show'] ? item['show'] : false
            let tokens = item['Varsome_link'].split('/')
            if (tokens.length > 1) {
              item['Varsome_link_N'] = '/' + tokens[tokens.length - 2] + '/' + tokens[tokens.length - 1]
            }
            item['chrPlus'] = item['Chr'] + '-' + item['Start'] + '-' + item['End'] + '-' + item['Ref'] + '-' + item['Alt']
            item['ZD8MG017_N'] = item['ZD8MG017'].substring(0, 3)

            item['AAChange-refGene'] = item['AAChange-refGene'].replace(/,/g, ', ')

            item['Disease_description-refGene'] = item['Disease_description-refGene'].replace(/Note\\x3d/g, '<br>Note: ').replace(/\\x3b/g, '<br>').replace(/_/g, ' ')
            item['Disease_description-refGene'] = cleanup(rebuildLinks(item['Disease_description-refGene']))

            item['Function_description-refGene'] = item['Function_description-refGene'].replace(/\\x3b/g, '; ').replace(/_/g, ' ').replace('FUNCTION:', '')
            item['Function_description-refGene'] = cleanup(rebuildLinks(item['Function_description-refGene']) )

            item['Interpro_domain'] = item['Interpro_domain'].replace(/\\x3b/g, '; ')

            item['CLNDISDB'] = item['CLNDISDB'].replace(/,/g, ', ')
            item['CLNDISDB'] = cleanup(rebuildLinks(item['CLNDISDB']))

            item['CLNDN'] = item['CLNDN'].replace(/_/g, ' ')
            item['CLNREVSTAT'] = item['CLNREVSTAT'].replace(/_/g, ' ')
            item['CLNSIG'] = item['CLNSIG'].replace(/_/g, ' ')

          })

        }
        this_.utility.dataLoading = false
      })
    },

  },
  watch: {
    reportId: function () {
      if (this.reportId) {
        this.loadReport()
      } else {
        this.regReport = {
          testId: "",
          reportId: "",
          title: "",
          data: "",
          results: [],
          dataFile: "",
          isReady: false,
          template: "generic"
        }
      }
    }
  },
  computed: {
    headers() {
      return [
        {text: 'Вкл', value: 'show'},
        {
          text: 'Gene',
          align: 'left',
          sortable: true,
          value: 'Gene-refGene'
        },
        {
          text: 'Classification',
          align: 'left',
          sortable: true,
          value: 'ACMG_classification'
        },
        {
          text: 'Probability',
          align: 'left',
          sortable: true,
          value: 'Probability_Path'
        },
        {
          text: 'Varsome',
          align: 'left',
          sortable: false,
          value: 'Varsome_link'
        },
        {
          text: 'Область',
          align: 'left',
          sortable: false,
          value: 'chrPlus'
        },
        {
          text: 'Func',
          align: 'left',
          sortable: false,
          value: 'Func-refGene'
        },
        {
          text: 'ExonicFunc',
          align: 'left',
          sortable: false,
          value: 'ExonicFunc-refGene'
        },
        {
          text: 'gnomAD exome ALL',
          align: 'left',
          sortable: false,
          value: 'gnomAD_exome_ALL'
        },
        {
          text: 'gnomAD genome ALL',
          align: 'left',
          sortable: false,
          value: 'gnomAD_genome_ALL'
        },

        {
          text: 'ZD8MG017',
          align: 'left',
          sortable: false,
          value: 'ZD8MG017'
        },


        {text: 'AAChange', value: 'AAChange-refGene', width: 200},
      ]
    },
    profileFormCanSave: function () {
      if (this.regReportFormValid) return true;
      return false;
    }
  },
  created: function () {
    if (this.reportId) {
      this.loadReport()
    }
  }

}
</script>

<style type="scss" scoped>

table.theme--light.v-table thead tr th, table.v-table thead tr th {
  padding: 0 6px !important;
  white-space: normal;
}

table.v-table thead th:not(:nth-child(1)) {
  padding: 0 6px !important;
  white-space: normal;
}

.theme--light.v-table tbody tr.first-row {
  border-width: 5px;
}

table tbody tr td.chk, table tr.first-row td, table tr.first-row td:first-child, table tr.first-row:first-child td, table.v-table tbody td.chk:first-child {
  padding: 16px 6px 6px 6px!important;
}

table tbody tr td.ctd {
  text-align: center;
}

table.v-table tbody tr.second-row, .theme--light.v-table tbody tr.second-row:not(:first-child) {
  border-top: none !important;
}

table tr.second-row td {
  padding: 6px 16px 16px 16px;
}

.v-table tr.first-row td.chr-plus {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

.v-table tr.first-row td.aachange {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

.v-table tr.first-row td.varsome {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.v-table tr.first-row td.ct {
  text-align: center;
}

.common-block {
  padding: 0 3px 20px 3px;
}

.pb-block {
  display: flex;
  flex-direction: row;
}

.pb-block .pb-it {
  background: #fff;
  border-left: 1px solid #ccc;
  text-align: center;
  border-bottom: 1px solid #ccc;
}

.pb-block .pb-it:last-child {
  border-right: 1px solid #ccc;
}

.pb-block .pb-it .pb-h {
  background: #eee;
  padding: 3px;
}

.pb-block .pb-el-list {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.pb-block .pb-el-list .pb-el {
  border-right: 1px dotted #ccc;
  text-align: center;
  padding: 3px;
}

.pb-block .pb-el-list .pb-el:hover {
  background: #ccc;
}

.pb-block .pb-el-list .pb-el:last-child {
  border-right: none;
}

table.v-table thead th {
  padding: 0 6px !important;
  white-space: normal !important;
}

</style>
